import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createBlock as _createBlock, vShow as _vShow, normalizeClass as _normalizeClass, Transition as _Transition, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "main-content" }
const _hoisted_2 = { id: "splash-screen-text" }
const _hoisted_3 = { id: "splash-screen-acknowledgements" }
const _hoisted_4 = { id: "splash-screen-logos" }
const _hoisted_5 = {
  key: 0,
  class: "no-background"
}
const _hoisted_6 = {
  key: 0,
  class: "container"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "top-content" }
const _hoisted_9 = {
  key: 0,
  id: "left-buttons"
}
const _hoisted_10 = { id: "center-buttons" }
const _hoisted_11 = {
  key: 0,
  class: "no-select"
}
const _hoisted_12 = { class: "no-select" }
const _hoisted_13 = { class: "bottom-content" }
const _hoisted_14 = {
  key: 0,
  id: "time-controls"
}
const _hoisted_15 = ["oninput"]
const _hoisted_16 = {
  key: 1,
  id: "time-controls",
  style: {"width":"50%"}
}
const _hoisted_17 = {
  key: 2,
  id: "body-logos"
}
const _hoisted_18 = { class: "video-wrapper" }
const _hoisted_19 = {
  id: "user-experience-footer",
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorldWideTelescope = _resolveComponent("WorldWideTelescope")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_credit_logos = _resolveComponent("credit-logos")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_icon_button = _resolveComponent("icon-button")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_funding_acknowledgement = _resolveComponent("funding-acknowledgement")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_user_experience = _resolveComponent("user-experience")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_cds_privacy_policy = _resolveComponent("cds-privacy-policy")!
  const _component_v_app = _resolveComponent("v-app")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "app",
    style: _normalizeStyle(_ctx.cssVars)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_WorldWideTelescope, { "wwt-namespace": _ctx.wwtNamespace }, null, 8, ["wwt-namespace"]),
        _createVNode(_component_v_overlay, {
          "model-value": _ctx.showSplashScreen,
          absolute: "",
          opacity: "0.6",
          style: _normalizeStyle(_ctx.cssVars),
          id: "splash-overlay"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              id: "splash-screen",
              style: _normalizeStyle(_ctx.cssVars)
            }, [
              _createVNode(_component_font_awesome_icon, {
                id: "close-splash-button",
                onClick: _ctx.closeSplashScreen,
                icon: "xmark"
              }, null, 8, ["onClick"]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("p", null, [
                  _cache[24] || (_cache[24] = _createTextVNode(" Want to surf a ")),
                  _createElementVNode("span", {
                    style: _normalizeStyle({'color': _ctx.accentColor})
                  }, "giant wave", 4),
                  _cache[25] || (_cache[25] = _createTextVNode(" in the Milky Way Galaxy? "))
                ])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_v_btn, {
                  class: "splash-get-started",
                  onClick: _ctx.closeSplashScreen,
                  color: _ctx.accentColor,
                  density: _ctx.xSmallSize ? 'compact' : 'default',
                  size: "x-large",
                  variant: "elevated",
                  rounded: "lg"
                }, {
                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                    _createTextVNode(" Get Started ")
                  ])),
                  _: 1
                }, 8, ["onClick", "color", "density"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _cache[27] || (_cache[27] = _createTextVNode(" Brought to you by ")),
                _cache[28] || (_cache[28] = _createElementVNode("a", {
                  href: "https://www.cosmicds.cfa.harvard.edu/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "Cosmic Data Stories", -1)),
                _cache[29] || (_cache[29] = _createTextVNode(" and ")),
                _cache[30] || (_cache[30] = _createElementVNode("a", {
                  href: "https://www.worldwidetelescope.org/home/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "WorldWide Telescope", -1)),
                _cache[31] || (_cache[31] = _createTextVNode(". ")),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_credit_logos, { "default-logos": ['cosmicds', 'wwt', 'sciact', 'nasa-grantee'] })
                ])
              ])
            ], 4)), [
              [_directive_click_outside, _ctx.closeSplashScreen]
            ])
          ]),
          _: 1
        }, 8, ["model-value", "style"]),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_5))
              : _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(['modal', _ctx.showSplashScreen ? 'no-background' : '']),
                  id: "modal-loading"
                }, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[32] || (_cache[32] = [
                        _createElementVNode("div", { class: "spinner" }, null, -1),
                        _createElementVNode("p", null, "Loading …", -1)
                      ])))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (!_ctx.showSplashScreen)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              id: "loading-button",
                              color: "white",
                              disabled: _ctx.isLoading,
                              variant: "outlined",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.userNotReady = false)),
                              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.userNotReady = false), ["enter"])),
                              elevation: "10",
                              size: _ctx.smallSize ? 'large' : 'x-large',
                              rounded: "lg",
                              "prepend-icon": "mdi-check-circle-outline"
                            }, {
                              default: _withCtx(() => _cache[33] || (_cache[33] = [
                                _createElementVNode("strong", null, "Start", -1)
                              ])),
                              _: 1
                            }, 8, ["disabled", "size"]))
                          : _createCommentVNode("", true)
                      ]))
                ], 2)), [
                  [_vShow, _ctx.isLoading || _ctx.userNotReady]
                ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.modeReactive != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_icon_button, {
                  "fa-icon": "house",
                  onActivate: _cache[2] || (_cache[2] = () => {
            _ctx.positionReset();
            _ctx.timeReset();
          }),
                  color: _ctx.buttonColor,
                  "tooltip-text": "Reset this view",
                  "tooltip-location": "start"
                }, null, 8, ["color"]),
                _createVNode(_component_icon_button, {
                  modelValue: _ctx.showTextSheet,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showTextSheet) = $event)),
                  "fa-icon": "book-open",
                  color: _ctx.buttonColor,
                  "tooltip-text": _ctx.showTextSheet ? 'Hide Info' : 'Learn More',
                  "tooltip-location": "start"
                }, null, 8, ["modelValue", "color", "tooltip-text"]),
                _createVNode(_component_icon_button, {
                  modelValue: _ctx.showVideoSheet,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showVideoSheet) = $event)),
                  "fa-icon": "video",
                  color: _ctx.buttonColor,
                  "tooltip-text": "Watch video",
                  "tooltip-location": "start"
                }, null, 8, ["modelValue", "color"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            false
              ? (_openBlock(), _createBlock(_component_icon_button, {
                  key: 0,
                  "md-icon": "mdi-sine-wave",
                  onActivate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleFullwaveMode())),
                  color: _ctx.buttonColor,
                  "tooltip-text": "Full Wave Mode",
                  "tooltip-location": "bottom"
                }, {
                  button: _withCtx(() => [
                    (_ctx.modeReactive != 'full')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "View the Full Radcliffe Wave"))
                      : _createCommentVNode("", true),
                    (_ctx.modeReactive == 'full')
                      ? (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                          default: _withCtx(() => _cache[34] || (_cache[34] = [
                            _createTextVNode("mdi-arrow-left")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["color"]))
              : _createCommentVNode("", true),
            ((_ctx.playCount > 0) ?? (_ctx.modeReactive == 'full'))
              ? (_openBlock(), _createBlock(_component_icon_button, {
                  key: 1,
                  onActivate: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modeReactive = _ctx.modeReactive == '3D' ? '2D' : '3D')),
                  color: _ctx.buttonColor,
                  "tooltip-text": "Switch modes",
                  "tooltip-location": "start"
                }, {
                  button: _withCtx(() => [
                    _createElementVNode("span", _hoisted_12, "See this " + _toDisplayString(_ctx.modeReactive == '3D' ? ' on the Sky (2D)' : 'in the Galaxy (3D)'), 1)
                  ]),
                  _: 1
                }, 8, ["color"]))
              : _createCommentVNode("", true),
            ((_ctx.playCount > 0) && _ctx.modeReactive=='3D')
              ? (_openBlock(), _createBlock(_component_icon_button, {
                  key: 2,
                  onActivate: _cache[7] || (_cache[7] = () => {
            _ctx.positionReset();
            _ctx.timeReset();
            _ctx.playing=true;
          }),
                  color: _ctx.buttonColor,
                  "tooltip-text": "Replay Wave Motion",
                  "tooltip-location": "end"
                }, {
                  button: _withCtx(() => _cache[35] || (_cache[35] = [
                    _createTextVNode(" Replay ")
                  ])),
                  _: 1
                }, 8, ["color"]))
              : _createCommentVNode("", true)
          ]),
          _cache[36] || (_cache[36] = _createElementVNode("div", { id: "right-buttons" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.modeReactive != '2D')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_icon_button, {
                  id: "play-pause-icon",
                  "fa-icon": !(_ctx.playing) ? 'play' : 'pause',
                  "fa-size": "xl",
                  onActivate: _cache[8] || (_cache[8] = () => {
            _ctx.playing = !(_ctx.playing);
          }),
                  color: _ctx.buttonColor,
                  "tooltip-text": "Play/Pause",
                  "tooltip-location": "top",
                  "tooltip-offset": "5px",
                  "show-tooltip": !_ctx.mobile
                }, null, 8, ["fa-icon", "color", "show-tooltip"]),
                _createElementVNode("input", {
                  type: "range",
                  id: "time-slider",
                  min: "0",
                  max: "720",
                  oninput: _ctx.onInputChange
                }, null, 8, _hoisted_15)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_ctx.modeReactive == '2D')
                  ? (_openBlock(), _createBlock(_component_v_select, {
                      key: 0,
                      modelValue: _ctx.background2DImageset,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.background2DImageset) = $event)),
                      items: _ctx.allSkyImagesets,
                      label: "Background",
                      outlined: "",
                      "hide-details": "",
                      color: _ctx.accentColor,
                      class: "pointer-events"
                    }, null, 8, ["modelValue", "items", "color"]))
                  : _createCommentVNode("", true)
              ])),
          (!_ctx.smallSize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_credit_logos, { "default-logos": ['cosmicds', 'wwt', 'sciact', 'nasa-grantee'] })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_v_dialog, {
          id: "video-container",
          modelValue: _ctx.showVideoSheet,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showVideoSheet) = $event)),
          transition: "slide-y-transition"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_font_awesome_icon, {
                id: "video-close-icon",
                class: "close-icon",
                icon: "times",
                size: "lg",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showVideoSheet = false)),
                onKeyup: _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.showVideoSheet = false), ["enter"])),
                tabindex: "0"
              }),
              _cache[37] || (_cache[37] = _createElementVNode("iframe", {
                id: "info-video",
                width: "560",
                height: "315",
                src: "https://www.youtube.com/embed/NJhbdSy6nss?si=tdyFAO_6qo_qVlhz",
                title: "YouTube video player",
                frameborder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                allowfullscreen: ""
              }, null, -1))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          style: _normalizeStyle(_ctx.cssVars),
          class: "bottom-sheet",
          id: "text-bottom-sheet",
          "hide-overlay": "",
          persistent: "",
          "no-click-animation": "",
          absolute: "",
          width: "100%",
          scrim: false,
          location: "bottom",
          modelValue: _ctx.showTextSheet,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showTextSheet) = $event)),
          transition: "dialog-bottom-transition"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { height: "100%" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs, {
                  modelValue: _ctx.tab,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.tab) = $event)),
                  height: "32px",
                  color: _ctx.accentColor,
                  "slider-color": _ctx.accentColor,
                  id: "tabs",
                  dense: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, {
                      class: "info-tabs",
                      tabindex: "0"
                    }, {
                      default: _withCtx(() => _cache[38] || (_cache[38] = [
                        _createElementVNode("h3", null, "Information", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, {
                      class: "info-tabs",
                      tabindex: "0"
                    }, {
                      default: _withCtx(() => _cache[39] || (_cache[39] = [
                        _createElementVNode("h3", null, "Using WWT", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "color", "slider-color"]),
                _createVNode(_component_font_awesome_icon, {
                  id: "close-text-icon",
                  class: "control-icon",
                  icon: "times",
                  size: "lg",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showTextSheet = false)),
                  onKeyup: _cache[15] || (_cache[15] = _withKeys(($event: any) => (_ctx.showTextSheet = false), ["enter"])),
                  tabindex: "0"
                }),
                _createVNode(_component_v_window, {
                  modelValue: _ctx.tab,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.tab) = $event)),
                  id: "tab-items",
                  class: "pb-2 no-bottom-border-radius"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "no-bottom-border-radius scrollable" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                              default: _withCtx(() => [
                                _cache[40] || (_cache[40] = _createElementVNode("h3", null, "What is the RadWave?", -1)),
                                _cache[41] || (_cache[41] = _createElementVNode("p", null, [
                                  _createTextVNode("The more humans study our universe, the more we find that it is richer and more complex than we previously realized. The Radcliffe Wave (or RadWave for short) is a massive structure that was discovered in our Milky Way galaxy by astronomers João Alves, Catherine Zucker, Alyssa Goodman, and others in 2020"),
                                  _createElementVNode("sup", null, [
                                    _createElementVNode("a", {
                                      href: "#2020team",
                                      class: "highlight"
                                    }, "[1]")
                                  ]),
                                  _createTextVNode(". The RadWave is made up of gas, dust, and stars loosely connected in a wave-like shape. It is so huge and so close to us that earlier scientists did not see that these parts were all connected. Learn more about the discovery of the RadWave here!")
                                ], -1)),
                                _cache[42] || (_cache[42] = _createElementVNode("h3", null, "How do scientists make predictions from models and data?", -1)),
                                _cache[43] || (_cache[43] = _createElementVNode("p", null, [
                                  _createTextVNode("The RadWave looks like a wave, but does it also move like a wave? Ralf Konietzka, with Goodman, Zucker, and others"),
                                  _createElementVNode("sup", null, [
                                    _createElementVNode("a", {
                                      href: "#2024team",
                                      class: "highlight"
                                    }, "[2]")
                                  ]),
                                  _createTextVNode(" used data from the Gaia satellite to answer this question by measuring the speed and direction of stars in different parts of the wave. Just like weather reporters can predict where a storm will go based on wind patterns, Konietzka uses the information about the RadWave’s current motion to predict how it will move in the future. The best model that fits the data is shown in this interactive.")
                                ], -1)),
                                _cache[44] || (_cache[44] = _createElementVNode("h3", null, "Why do the blue star clusters fade out?", -1)),
                                _cache[45] || (_cache[45] = _createElementVNode("p", null, "The time it takes for the RadWave to complete a “wave” is about 100 million years, but the clouds and young star clusters along the wave will disperse in less than 30 million years, so the blue dots that represent the star clusters fade out in the interactive view to reflect this.", -1)),
                                _cache[46] || (_cache[46] = _createElementVNode("h3", null, "Science Credits", -1)),
                                _cache[47] || (_cache[47] = _createElementVNode("p", null, [
                                  _createTextVNode("[1] "),
                                  _createElementVNode("span", {
                                    class: "highlight",
                                    id: "2020team"
                                  }, "2020 RadWave Team: "),
                                  _createTextVNode(" João Alves, Catherine Zucker, Alyssa A. Goodman, Joshua S. Speagle, Stefan Meingast, Thomas Robitaille, Douglas P. Finkbeiner, Edward F. Schlafly, and Gregory M. Green")
                                ], -1)),
                                _cache[48] || (_cache[48] = _createElementVNode("p", null, [
                                  _createTextVNode("[2] "),
                                  _createElementVNode("span", {
                                    class: "highlight",
                                    id: "2024team"
                                  }, "2024 RadWave in Motion Team:"),
                                  _createTextVNode(" Ralf Konietzka, Alyssa A. Goodman, Catherine Zucker, Andreas Burkert, João Alves, Michael Foley, Cameren Swiggum, Maria Koller, and Núria Miret-Roig")
                                ], -1)),
                                _createVNode(_component_v_spacer, { class: "end-spacer" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "no-bottom-border-radius scrollable" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_container, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { align: "center" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "4" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_chip, {
                                              label: "",
                                              outlined: ""
                                            }, {
                                              default: _withCtx(() => _cache[49] || (_cache[49] = [
                                                _createTextVNode(" Pan ")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "8",
                                          class: "pt-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "press + drag" : "click + drag"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "or") + " ", 1),
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "" : "W-A-S-D"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "keys"), 1),
                                            _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, { align: "center" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "4" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_chip, {
                                              label: "",
                                              outlined: ""
                                            }, {
                                              default: _withCtx(() => _cache[51] || (_cache[51] = [
                                                _createTextVNode(" Zoom ")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "8",
                                          class: "pt-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "pinch in and out" : "scroll in and out"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "or") + " ", 1),
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "" : "I-O"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? "" : "keys"), 1),
                                            _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => _cache[53] || (_cache[53] = [
                                            _createElementVNode("div", { class: "credits" }, [
                                              _createElementVNode("h3", null, "Science Credits:"),
                                              _createTextVNode(" Ralf Konietzka"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Catherine Zucker"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Alyssa A. Goodman"),
                                              _createElementVNode("br")
                                            ], -1),
                                            _createElementVNode("div", { class: "credits" }, [
                                              _createElementVNode("h3", null, "Credits:"),
                                              _createElementVNode("p", null, "This Data Story is powered by WorldWide Telescope."),
                                              _createElementVNode("h4", null, [
                                                _createElementVNode("a", {
                                                  href: "https://www.cosmicds.cfa.harvard.edu/",
                                                  target: "_blank",
                                                  rel: "noopener noreferrer"
                                                }, "CosmicDS"),
                                                _createTextVNode(" Team:")
                                              ]),
                                              _createTextVNode(" Jon Carifio"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" John Lewis"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Pat Udomprasert"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Alyssa Goodman"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Mary Dussault"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Harry Houghton"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Anna Nolin"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Evaluator: Sue Sunbury"),
                                              _createElementVNode("br"),
                                              _createElementVNode("br"),
                                              _createElementVNode("h4", null, "WorldWide Telescope Team:"),
                                              _createTextVNode(" Peter Williams"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" A. David Weigel"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Jon Carifio"),
                                              _createElementVNode("br")
                                            ], -1)
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_funding_acknowledgement)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_spacer, { class: "end-spacer" })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style", "modelValue"]),
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_expand_transition, null, {
              default: _withCtx(() => [
                (_ctx.showRating)
                  ? (_openBlock(), _createBlock(_component_user_experience, {
                      key: 0,
                      question: _ctx.question,
                      "icon-size": "3x",
                      onDismiss: _cache[20] || (_cache[20] = (_rating, _comments) => {
            _ctx.showRating = false;
          }),
                      onRating: _cache[21] || (_cache[21] = (rating) => {
            _ctx.currentRating = rating;
            _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
          }),
                      onFinish: _cache[22] || (_cache[22] = (rating, comments) => {
            _ctx.currentRating = rating;
            _ctx.currentComments = comments;
            _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
            _ctx.showRating = false;
          })
                    }, {
                      footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_v_btn, {
                            class: "rating-opt-put",
                            color: "#BDBDBD",
                            size: "small",
                            variant: "text",
                            onClick: _ctx.onOptOutClicked
                          }, {
                            default: _withCtx(() => _cache[54] || (_cache[54] = [
                              _createTextVNode(" Don't show again ")
                            ])),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            class: "privacy-button",
                            color: "#BDBDBD",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showPrivacyPolicy = true)),
                            onKeyup: _cache[19] || (_cache[19] = _withKeys(($event: any) => (_ctx.showPrivacyPolicy = true), ["enter"])),
                            size: "small",
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, {
                            default: _withCtx(() => _cache[55] || (_cache[55] = [
                              _createTextVNode(" What is this? ")
                            ])),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["question"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_cds_privacy_policy, {
              modelValue: _ctx.showPrivacyPolicy,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.showPrivacyPolicy) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["style"]))
}